import { Button } from '@wix/design-system'
import { useContent, useNext, usePageLoading } from '@wix/funnel-builder-lizard'
import cs from 'classnames'
import React, { ChangeEvent, FC, ReactNode, useEffect, useState } from 'react'

import { usePageLogger } from '../../../bi/mfi'
import WixLogo from '../../reusable/icons/WixLogo.svg'
import WixVibeLogo from '../../reusable/icons/WixVibeLogo.svg'
import { TWixVibeMobileSplitNavigation as Content } from './WixVibeMobileSplitNavigation.content'
import s from './WixVibeMobileSplitNavigation.scss'

const IMG_MAP = {
  wix: <WixLogo height="10px" />,
  'wix-vibe': <WixVibeLogo height="10px" />,
} as Record<string, ReactNode>

export const WixVibeMobileSplitNavigation: FC = () => {
  const [isPageLoading] = usePageLoading()
  const { content } = useContent<Content>()
  const pageLogger = usePageLogger()
  const next = useNext()

  const [selectedValue, setSelectedValue] = useState<string>('')

  useEffect(() => {
    void pageLogger.screenView()
  }, [pageLogger])

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(e.target.value)
  }

  const onContinue = () => {
    if (isPageLoading) {
      return
    }

    void pageLogger.answer({ answer: selectedValue })
    next({
      [content.question.questionKey]: { values: [selectedValue] },
    })
  }

  return (
    <div className={s.page}>
      <div className={s.header}>
        <WixLogo height="24px" />
      </div>
      <div className={s.container}>
        <h1 className={s.title}>{content.question.content.title}</h1>
        <div className={s.navigation}>
          {content.question.options.map(({ label, description, tag, optionKey }, i) => (
            <label key={label} className={cs(s.radioLabel, { [s.tag]: tag })} data-text={tag}>
              <input
                onChange={onChange}
                className={s.input}
                name="wix-vibe-mobile-split-navigation"
                value={optionKey}
                type="radio"
              />

              <div
                className={cs(s.icon, { [s.wixIcon]: optionKey === 'wix', [s.wixVibeIcon]: optionKey === 'wix-vibe' })}
              >
                {IMG_MAP[optionKey]}
              </div>
              <div className={s.content}>
                <span className={cs(s.text, s.label)}>{label}</span>
                <span className={cs(s.text, s.description)}>{description}</span>
              </div>
            </label>
          ))}
        </div>
        <Button disabled={!selectedValue} onClick={onContinue} className={s.next}>
          {content.question.content.next}
        </Button>
      </div>
    </div>
  )
}
